import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const feeAccountSelector = ({ feeAccount }: ReducerState) => feeAccount;
export const feeAccountLoadingSelector = createSelector(
  feeAccountSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
